export const ONLY_DIGITS_REGEX = /\D/g;

export const LEADING_DIAL_CODE_REGEX = /^\+\d+/;

export const PHONE_MAX_LENGTH = 14;

export const INVALID_PHONE_NUMBER_ERROR = 'Please provide a valid phone number';

export const CLIPBOARD_TEXT_FORMAT = 'Text';
